import React from 'react';
import { CustomerProfile } from '@/redux/slices/slice_types';
import axios from '@/_utils/axios';
import OverflowMenuItem from '@/components/_common/OverflowMenu/OverflowMenuItem';
import PolarisIcon from '@/components/_common/PolarisIcon';
import { useToast } from '@/components/_common/Toast';
import { useAppSelector } from '@/redux/hooks';
import { selectCanExportProfiles } from '@/redux/selectors/authSelectors';
import { exportStringAsJsonFile } from '@/_utils/utils';

type ProfileExportProps = {
  profile: CustomerProfile;
};

const ProfileExport = ({ profile }: ProfileExportProps) => {
  const canExportProfiles = useAppSelector(selectCanExportProfiles);
  const { error } = useToast();

  const onExport = async () => {
    if (!profile?.id) return;
    try {
      const res = await axios.get(`/core/profile_templates/${profile.id}/export/`);

      if (res.data) {
        const name = res.data.name;
        exportStringAsJsonFile(name, JSON.stringify(res.data, null, 2));
      }
    } catch (err: any) {
      error(err?.data?.message || 'There was a problem exporting the profile.');
    }
  };

  if (!canExportProfiles) return null;

  return (
    <OverflowMenuItem onClick={onExport}>
      <PolarisIcon icon="download" height={14} />
      Export Profile
    </OverflowMenuItem>
  );
};

export default ProfileExport;
